import React from 'react';

import { Route, Switch } from 'react-router-dom';

import { Layout } from 'antd';

import MainPage from 'AppClient/routes/MainPage';
import UserProfile from 'AppClient/routes/UserProfile';

const { Content } = Layout;

export const PATHS = {
	myBookings: '',
	userProfile: 'userProfile',
	testAddress: 'testAddress',
	staticRatings: 'staticRatings',
};
interface AppContentProps {}

const AppContent: React.FC<AppContentProps> = () => (
	<Content>
		<Switch>
			<Route component={MainPage} exact path={`/${PATHS.myBookings}`} />
			<Route component={UserProfile} exact path={`/${PATHS.userProfile}`} />

			{/*
			<Route component={TestAddress} exact path={`/${PATHS.testAddress}`} />
			<Route component={StaticRatings} exact path={`/${PATHS.staticRatings}`} />
			*/}
		</Switch>
	</Content>
);

export default AppContent;
